export default "__VITE_ASSET__7e6f8584__"